import LoginContainer from "../containers/login/login.container";

const Login = () => {
  return <LoginContainer />
}

export default Login
